/* eslint-disable @typescript-eslint/no-unused-expressions */
import Prism from "prismjs";

Prism.languages.javascript = Prism.languages.extend("javascript", {});
Prism.languages.insertBefore("javascript", "prolog", {
  comment: { pattern: /\/\/[^\n]*/, alias: "comment" },
});
